import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class LoyaltyVIPTiers {
  constructor() {
    this.$el = document.querySelector(".js-loyalty-vip-tiers");

    if (!this.$el) {
      return;
    }
    this.$title = this.$el.querySelector(".js-loyalty-vip-tiers-title");
    this.$description = this.$el.querySelector(
      ".js-loyalty-vip-tiers-description"
    );
    this.$track = this.$el.querySelector(".js-loyalty-vip-tiers-track");
    this.$items = this.$el.querySelectorAll(".js-loyalty-vip-tiers-item");
    this.$stage = this.$el.querySelector(".js-loyalty-vip-tiers-stage");

    this.$tick1 = this.$el.querySelector(".js-loyalty-vip-tiers-item-tick-1");
    this.$tick2 = this.$el.querySelector(".js-loyalty-vip-tiers-item-tick-2");
    this.$tick3 = this.$el.querySelector(".js-loyalty-vip-tiers-item-tick-3");
    this.$tick4 = this.$el.querySelector(".js-loyalty-vip-tiers-item-tick-4");

    this.$frame1 = this.$el.querySelector(".js-loyalty-vip-tiers-frame-1");
    this.$frame2 = this.$el.querySelector(".js-loyalty-vip-tiers-frame-2");
    this.$frame3 = this.$el.querySelector(".js-loyalty-vip-tiers-frame-3");
    this.$frame4 = this.$el.querySelector(".js-loyalty-vip-tiers-frame-4");

    this.ticks = [this.$tick1, this.$tick2, this.$tick3, this.$tick4];
    this.frames = [this.$frame1, this.$frame2, this.$frame3, this.$frame4];

    this.animate();
  }

  animate() {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el,
        pin: window.innerWidth > 1024,
        scrub: true,
        end: window.innerWidth > 1024 ? "+=500" : undefined,
        anticipatePin: 1,
      },
    });

    timeline
      .fromTo(
        this.$track,
        {
          height: "0%",
        },
        {
          delay: 10,
          height: "100%",
          duration: 40,
          ease: "expo.out",
        }
      )
      .fromTo(
        this.ticks,
        {
          scale: 0,
        },
        {
          scale: 1,
          duration: 10,
          stagger: 5,
          ease: "expo.out",
        },
        "-=40"
      )
      .fromTo(
        this.frames,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 10,
          stagger: 5,
          ease: "expo.out",
        },
        "-=40"
      );
  }
}
